import Vue from 'vue/dist/vue.esm.js'
const d = document

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')

const init = () => {
  const input_template = d.querySelector('#input')
  const input_templateDOM = new DOMParser().parseFromString( input_template.innerHTML, 'text/html' )
  const enquete_children = JSON.parse( input_templateDOM.querySelector('[name="__children[アンケート][]"]').value )
  
  const edit_template = d.querySelector('#enqueteEdit')
  const edit_templateDOM = new DOMParser().parseFromString( edit_template.innerHTML, 'text/html' )

  $('input[name="アンケート"][type="radio"]',edit_templateDOM).each( (i,obj) => {
    $.each(enquete_children, (key,val) => $(obj).before( $(`<label class="horizontal-item"><input type="radio" name="アンケート" v-model="editdata.enquete" class="form-check-input" value="${key}">${val}</label>`)[0] ))
    $(obj).remove()
  })

  edit_template.innerHTML = edit_templateDOM.body.outerHTML
}

if( is_confirm ) init()

export default Vue.component( 'enqueteEdit', {
  template: '#enqueteEdit',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    formdata: Object
  },
  data () {
    return {
      editdata: {
        enquete: this.formdata.enquete,
        popy_agent: this.formdata.popy_agent,
        memo: this.formdata.memo
      }
    }
  },
  mounted () {
    if( is_input ) this.$router.replace('/')
  },
  methods: {
    update(){
      this.$emit('upd-section', this.editdata)
      this.$router.push('/')
    }
  }
})


